import React, { useState, useRef } from 'react';
import { TextField, IconButton, Button } from '@mui/material';
import { styled } from '@mui/system';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import '../../../../style/components/dashed-text-field.less';
import { translate } from '../../../services';

const theme = createTheme({
  typography: {
    fontFamily: 'ABBvoice Regular', // Replace with your desired font family
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontFamily: 'ABBvoice Regular', // Apply font family to input
        },
      },
    },
  },
});

const DashedTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      border: '2px dashed #BABABA', // Dashed border for the TextField
      display: 'flex',
      alignItems: 'center',
      minHeight: '80px', // Set a fixed height for the TextField
    },
    '&:hover fieldset': {
      border: '2px dashed #BABABA', // Dashed border on hover
    },
    '&.Mui-focused fieldset': {
      border: '2px dashed #BABABA', // Dashed border when focused
    },
    justifyContent: 'center !important',
  },
  '& .MuiInputBase-input': {
    display: 'none', // Hide the input
  },
});

const FileInput = styled('input')({
  display: 'none',
});

const DashedTextFieldWithDrop = ({ files, onFileChange, onDrop, onDelete, onDeleteAll }) => {
  const [isFocused, setIsFocused] = useState(false);
  const fileInputRef = useRef();

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  return (
    <ThemeProvider theme={theme}>
      <div
        onDrop={onDrop}
        onDragOver={(e) => e.preventDefault()}
        style={{ position: 'relative' }}
      >
        <DashedTextField
          label={translate('SupportPage.Attachments')}
          InputLabelProps={{
            shrink: isFocused || files.length > 0,
          }}
          fullWidth
          variant="outlined"
          margin="dense"
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          InputProps={{
            readOnly: true,
            endAdornment: (
              <div className="attachments">
                <div className="dragdropmessage">
                {translate('SupportPage.DragAndDrop')}
                </div>
                <IconButton className="add-button" onClick={handleButtonClick}>
                  <AddIcon />
                </IconButton>
                <FileInput
                  type="file"
                  ref={fileInputRef}
                  onChange={onFileChange}
                  multiple
                />
                {files.length >= 2 && (
                  <IconButton onClick={onDeleteAll} style={{ marginTop: '5px' }}>
                    <DeleteIcon style={{ color: '#E12E2E' }}/>
                    <span className='file-name'>{translate('SupportPage.DeleteAll')}</span>
                  </IconButton>
                )}
                <div>
                  {files.map((file, index) => (
                    <div key={index} className="file-list">
                      <span className='file-name'>{file.name}</span>
                      <IconButton style={{ padding: '2px' }} onClick={() => onDelete(index)} >
                        <DeleteIcon style={{ color: '#E12E2E' }}/>
                      </IconButton>
                    </div>
                  ))}
                </div>
              </div>
            ),
          }}
        />
      </div>
    </ThemeProvider>
  );
};

export default DashedTextFieldWithDrop;
